import { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Box,
  Divider,
  Card,
  CardContent,
  Container,
  Stack,
  Chip,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import FolderIcon from "@mui/icons-material/Folder";
import SecurityIcon from "@mui/icons-material/Security";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import { NotificationManager } from "react-notifications";
import {
  UpdateSystemConfigurations,
  GetSystemConfigurations,
} from "../../services/GeneralMaintenanceService";
import MultiEmailInput from '../common/MultiEmailInput';
import CommonLoader from "../common/CommonLoader";
import "react-quill/dist/quill.snow.css";

const UpdateSystemConfiguration = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    companyAddress1: "",
    companyAddress2: "",
    companyZipCode: "",
    companyPhone1: "",
    companyPhone2: "",
    companyEmail1: "",
    companyEmail2: "",
    salesContact: "",
    officeManager: "",
    labManager: "",
    qcmanager: "",
    smtpaddress: "",
    smtpaccount: "",
    smtppassword: "",
    attachmentFilePath: "",
    htmlfilePath: "",
    labReportEmailSender: "",
    labReportEmailSubject: "",
    billingReportEmailSender: "",
    billingReportEmailSubject: "",
    companyCity: "",
    companyState: "",
    emailEtkUpdates: false,
    cmdpUsername: "",
    cmdpPass: "",
    cmdpEmail: "",
    rulesJson: "",

    quoteGenericComment: "",
    quoteWasteWaterComment: "",
    quoteDrinkingWaterComment: "",

    pfasFromEmail: "",
    eurofinsToEmails: "",
    pfasccEmails: "",
    pfasEmailSubject: "",

    aiSummarySystemPrompt: "",

    // ENB-584 daily inventory reorder email
    inventoryReorderFromEmail: "",
    inventoryReorderToEmails: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const loadConfigurations = async () => {
      try {
        setLoading(true);
        const response = await GetSystemConfigurations();
        setFormData({
          companyName: response.results.companyName || "",
          companyAddress1: response.results.companyAddress1 || "",
          companyAddress2: response.results.companyAddress2 || "",
          companyZipCode: response.results.companyZipCode || "",
          companyPhone1: response.results.companyPhone1 || "",
          companyPhone2: response.results.companyPhone2 || "",
          companyEmail1: response.results.companyEmail1 || "",
          companyEmail2: response.results.companyEmail2 || "",
          salesContact: response.results.salesContact || "",
          officeManager: response.results.officeManager || "",
          labManager: response.results.labManager || "",
          qcmanager: response.results.qcmanager || "",
          smtpaddress: response.results.smtpaddress || "",
          smtpaccount: response.results.smtpaccount || "",
          smtppassword: response.results.smtppassword || "",
          attachmentFilePath: response.results.attachmentFilePath || "",
          htmlfilePath: response.results.htmlfilePath || "",
          labReportEmailSender: response.results.labReportEmailSender || "",
          labReportEmailSubject: response.results.labReportEmailSubject || "",
          billingReportEmailSender:
            response.results.billingReportEmailSender || "",
          billingReportEmailSubject:
            response.results.billingReportEmailSubject || "",
          companyCity: response.results.companyCity || "",
          companyState: response.results.companyState || "",
          emailEtkUpdates: response.results.emailEtkUpdates || false,
          cmdpUsername: response.results.cmdpUsername || "",
          cmdpPass: response.results.cmdpPass || "",
          cmdpEmail: response.results.cmdpEmail || "",
          rulesJson: response.results.rulesJson || "",
          quoteGenericComment: response.results.quoteGenericComment || "",
          quoteWasteWaterComment: response.results.quoteWasteWaterComment || "",
          quoteDrinkingWaterComment: response.results.quoteDrinkingWaterComment || "",
          pfasFromEmail: response.results.pfasFromEmail || "",
          eurofinsToEmails: response.results.eurofinsToEmails || "",
          pfasccEmails: response.results.pfasccEmails || "",
          pfasEmailSubject: response.results.pfasEmailSubject || "",
          aiSummarySystemPrompt: response.results.aiSummarySystemPrompt || "",
          inventoryReorderFromEmail: response.results.inventoryReorderFromEmail || "",
          inventoryReorderToEmails: response.results.inventoryReorderToEmails || "",
        });
      } catch (error) {
        NotificationManager.error("Failed to load configurations.");
      } finally {
        setLoading(false);
      }
    };

    loadConfigurations();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleMultiEmailChange = (field) => (value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: typeof value === "string" ? value : "",
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.companyName) errors.companyName = "Company Name is required.";
    if (!formData.companyAddress1)
      errors.companyAddress1 = "Company Address 1 is required.";
    if (!formData.companyAddress2)
      errors.companyAddress2 = "Company Address 2 is required.";
    if (!formData.companyZipCode)
      errors.companyZipCode = "Company Zip Code is required.";
    if (!formData.companyPhone1)
      errors.companyPhone1 = "Company Phone 1 is required.";
    if (!formData.companyPhone2)
      errors.companyPhone2 = "Company Phone 2 is required.";
    if (!formData.companyEmail1)
      errors.companyEmail1 = "Company Email 1 is required.";
    if (!formData.companyEmail2)
      errors.companyEmail2 = "Company Email 2 is required.";
    if (!formData.salesContact)
      errors.salesContact = "Sales Contact is required.";
    if (!formData.officeManager)
      errors.officeManager = "Office Manager is required.";
    if (!formData.labManager) errors.labManager = "Lab Manager is required.";
    if (!formData.qcmanager) errors.qcmanager = "QC Manager is required.";
    if (!formData.smtpaddress) errors.smtpaddress = "SMTP Address is required.";
    if (!formData.smtpaccount) errors.smtpaccount = "SMTP Account is required.";
    if (!formData.smtppassword)
      errors.smtppassword = "SMTP Password is required.";
    if (!formData.attachmentFilePath)
      errors.attachmentFilePath = "Attachment File Path is required.";
    if (!formData.htmlfilePath)
      errors.htmlfilePath = "HTML File Path is required.";
    if (!formData.labReportEmailSender)
      errors.labReportEmailSender = "Lab Report Email Sender is required.";
    if (!formData.labReportEmailSubject)
      errors.labReportEmailSubject = "Lab Report Email Subject is required.";
    if (!formData.billingReportEmailSender)
      errors.billingReportEmailSender =
        "Billing Report Email Sender is required.";
    if (!formData.billingReportEmailSubject)
      errors.billingReportEmailSubject =
        "Billing Report Email Subject is required.";
    if (!formData.companyCity) errors.companyCity = "Company City is required.";
    if (!formData.companyState)
      errors.companyState = "Company State is required.";
    if (!formData.cmdpUsername)
      errors.cmdpUsername = "CMDP Username is required.";
    if (!formData.cmdpPass) errors.cmdpPass = "CMDP Password is required.";
    if (!formData.cmdpEmail) errors.cmdpEmail = "CMDP Email is required.";
    if (!formData.rulesJson) errors.rulesJson = "Rules JSON is required.";

    if (!formData.pfasFromEmail)
      errors.pfasFromEmail = "PFAS From Email is required.";

    if (!formData.eurofinsToEmails)
      errors.eurofinsToEmails = "Eurofins To Emails is required.";

    if (!formData.pfasEmailSubject)
      errors.pfasEmailSubject = "PFAS Email Subject is required.";


    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((error) =>
        NotificationManager.error(error)
      );
      return false;
    }

    return true;
  };

  const handleSaveClick = async () => {
    if (validateForm()) {
      try {
        setLoading(true);
        await UpdateSystemConfigurations(formData);
        NotificationManager.success("Configuration updated successfully.");
        window.location.href = "/vlp/settings-system-configuration";
      } catch (error) {
        NotificationManager.error("Failed to update configuration.");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCancelClick = () => {
    // Redirect to settings page on cancel
    window.location.href = "/vlp/settings-system-configuration";
  };

  return (
    <>
      {loading && <CommonLoader loading={loading} />}
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: 600,
              color: "primary.main",
            }}
          >
            <SettingsIcon fontSize="large" />
            System Configuration
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            Manage your system settings and configuration parameters
          </Typography>
          <Divider sx={{ mt: 2 }} />
        </Box>

        <Stack spacing={2}>
          {/* Company Information Section */}
          <Card variant="outlined" sx={{ overflow: "visible" }}>
            <CardContent sx={{ pb: 2 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <BusinessIcon color="primary" fontSize="small" />
                <Typography variant="h6" fontWeight={500}>
                  Company Information
                </Typography>
                <Chip
                  label="Required"
                  size="small"
                  color="error"
                  variant="outlined"
                />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Company Name"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.companyName}
                    helperText={errors.companyName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Company Address 1"
                    name="companyAddress1"
                    value={formData.companyAddress1}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.companyAddress1}
                    helperText={errors.companyAddress1}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Company Address 2"
                    name="companyAddress2"
                    value={formData.companyAddress2}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.companyAddress2}
                    helperText={errors.companyAddress2}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Company City"
                    name="companyCity"
                    value={formData.companyCity}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.companyCity}
                    helperText={errors.companyCity}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Company State"
                    name="companyState"
                    value={formData.companyState}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.companyState}
                    helperText={errors.companyState}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Company Zip Code"
                    name="companyZipCode"
                    value={formData.companyZipCode}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.companyZipCode}
                    helperText={errors.companyZipCode}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Contact Information Section */}
          <Card variant="outlined" sx={{ overflow: "visible" }}>
            <CardContent sx={{ pb: 2 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <EmailIcon color="primary" fontSize="small" />
                <Typography variant="h6" fontWeight={500}>
                  Contact Information
                </Typography>
                <Chip
                  label="Required"
                  size="small"
                  color="error"
                  variant="outlined"
                />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Company Phone 1"
                    name="companyPhone1"
                    value={formData.companyPhone1}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="tel"
                    error={!!errors.companyPhone1}
                    helperText={errors.companyPhone1}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Company Phone 2"
                    name="companyPhone2"
                    value={formData.companyPhone2}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="tel"
                    error={!!errors.companyPhone2}
                    helperText={errors.companyPhone2}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Company Email 1"
                    name="companyEmail1"
                    value={formData.companyEmail1}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="email"
                    error={!!errors.companyEmail1}
                    helperText={errors.companyEmail1}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Company Email 2"
                    name="companyEmail2"
                    value={formData.companyEmail2}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="email"
                    error={!!errors.companyEmail2}
                    helperText={errors.companyEmail2}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Personnel and SMTP in same row */}
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <Card
                variant="outlined"
                sx={{ height: "100%", overflow: "visible" }}
              >
                <CardContent sx={{ pb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <PersonIcon color="primary" fontSize="small" />
                    <Typography variant="h6" fontWeight={500}>
                      Personnel
                    </Typography>
                    <Chip
                      label="Required"
                      size="small"
                      color="error"
                      variant="outlined"
                    />
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Sales Contact"
                        name="salesContact"
                        value={formData.salesContact}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={!!errors.salesContact}
                        helperText={errors.salesContact}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Office Manager"
                        name="officeManager"
                        value={formData.officeManager}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={!!errors.officeManager}
                        helperText={errors.officeManager}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Lab Manager"
                        name="labManager"
                        value={formData.labManager}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={!!errors.labManager}
                        helperText={errors.labManager}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="QC Manager"
                        name="qcmanager"
                        value={formData.qcmanager}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={!!errors.qcmanager}
                        helperText={errors.qcmanager}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} lg={6}>
              <Card
                variant="outlined"
                sx={{ height: "100%", overflow: "visible" }}
              >
                <CardContent sx={{ pb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <EmailIcon color="primary" fontSize="small" />
                    <Typography variant="h6" fontWeight={500}>
                      SMTP Configuration
                    </Typography>
                    <Chip
                      label="Required"
                      size="small"
                      color="error"
                      variant="outlined"
                    />
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label="SMTP Address"
                        name="smtpaddress"
                        value={formData.smtpaddress}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={!!errors.smtpaddress}
                        helperText={errors.smtpaddress}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="SMTP Account"
                        name="smtpaccount"
                        value={formData.smtpaccount}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={!!errors.smtpaccount}
                        helperText={errors.smtpaccount}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="SMTP Password"
                        name="smtppassword"
                        value={formData.smtppassword}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="text"
                        error={!!errors.smtppassword}
                        helperText={errors.smtppassword}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* File Paths and Email Settings Section */}
          <Card variant="outlined" sx={{ overflow: "visible" }}>
            <CardContent sx={{ pb: 2 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <FolderIcon color="primary" fontSize="small" />
                <Typography variant="h6" fontWeight={500}>
                  File Paths & Email Settings
                </Typography>
                <Chip
                  label="Required"
                  size="small"
                  color="error"
                  variant="outlined"
                />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Attachment File Path"
                    name="attachmentFilePath"
                    value={formData.attachmentFilePath}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.attachmentFilePath}
                    helperText={errors.attachmentFilePath}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="HTML File Path"
                    name="htmlfilePath"
                    value={formData.htmlfilePath}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.htmlfilePath}
                    helperText={errors.htmlfilePath}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Lab Report Email Sender"
                    name="labReportEmailSender"
                    value={formData.labReportEmailSender}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="email"
                    error={!!errors.labReportEmailSender}
                    helperText={errors.labReportEmailSender}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Lab Report Email Subject"
                    name="labReportEmailSubject"
                    value={formData.labReportEmailSubject}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.labReportEmailSubject}
                    helperText={errors.labReportEmailSubject}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Billing Report Email Sender"
                    name="billingReportEmailSender"
                    value={formData.billingReportEmailSender}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="email"
                    error={!!errors.billingReportEmailSender}
                    helperText={errors.billingReportEmailSender}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    label="Billing Report Email Subject"
                    name="billingReportEmailSubject"
                    value={formData.billingReportEmailSubject}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.billingReportEmailSubject}
                    helperText={errors.billingReportEmailSubject}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* CMDP and Rules in same row */}
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <Card
                variant="outlined"
                sx={{ height: "100%", overflow: "visible" }}
              >
                <CardContent sx={{ pb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <SecurityIcon color="primary" fontSize="small" />
                    <Typography variant="h6" fontWeight={500}>
                      CMDP Configuration
                    </Typography>
                    <Chip
                      label="Required"
                      size="small"
                      color="error"
                      variant="outlined"
                    />
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label="CMDP Username"
                        name="cmdpUsername"
                        value={formData.cmdpUsername}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={!!errors.cmdpUsername}
                        helperText={errors.cmdpUsername}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="CMDP Password"
                        name="cmdpPass"
                        value={formData.cmdpPass}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="text"
                        error={!!errors.cmdpPass}
                        helperText={errors.cmdpPass}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="CMDP Email"
                        name="cmdpEmail"
                        value={formData.cmdpEmail}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="email"
                        error={!!errors.cmdpEmail}
                        helperText={errors.cmdpEmail}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} lg={6}>
              <Card
                variant="outlined"
                sx={{ height: "100%", overflow: "visible" }}
              >
                <CardContent sx={{ pb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <SettingsIcon color="primary" fontSize="small" />
                    <Typography variant="h6" fontWeight={500}>
                      Additional Settings
                    </Typography>
                    <Chip
                      label="Required"
                      size="small"
                      color="error"
                      variant="outlined"
                    />
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label="Rules JSON"
                        name="rulesJson"
                        value={formData.rulesJson}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                        multiline
                        rows={3}
                        error={!!errors.rulesJson}
                        helperText={
                          errors.rulesJson || "Enter valid JSON configuration"
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 1,
                          p: 2,
                          bgcolor: "grey.50",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.emailEtkUpdates}
                              onChange={handleChange}
                              name="emailEtkUpdates"
                              color="primary"
                            />
                          }
                          label={
                            <Box>
                              <Typography variant="body2" fontWeight={500}>
                                Email ETK Updates
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Enable automatic email notifications for ETK
                                updates
                              </Typography>
                            </Box>
                          }
                        />
                      </Box>
                    </Grid>
                  </Grid>

                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} lg={6}>
              <Card variant="outlined" sx={{ height: "100%", overflow: "visible" }}>
                <CardContent sx={{ pb: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                    <EmailIcon color="primary" fontSize="small" />
                    <Typography variant="h6" fontWeight={500}>
                      PFAS Results from Eurofins
                    </Typography>
                    <Chip label="Required" size="small" color="error" variant="outlined" />
                  </Box>

                  <Grid container spacing={2}>
                    {/* Row 1 */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="From Email"
                        name="pfasFromEmail"
                        value={formData.pfasFromEmail}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        type="email"
                        error={!!errors.pfasFromEmail}
                        helperText={errors.pfasFromEmail}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Email Subject"
                        name="pfasEmailSubject"
                        value={formData.pfasEmailSubject}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        error={!!errors.pfasEmailSubject}
                        helperText={errors.pfasEmailSubject}
                      />
                    </Grid>

                    {/* Row 2 */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Eurofins To Emails"
                        name="eurofinsToEmails"
                        value={formData.eurofinsToEmails || ""}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        placeholder="Comma-separated emails"
                        error={!!errors.eurofinsToEmails}
                        helperText={errors.eurofinsToEmails}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="CC Emails"
                        name="pfasccEmails"
                        value={formData.pfasccEmails || ""}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        placeholder="Optional, comma-separated"
                      />
                    </Grid>

                    {/* ENB-584: daily inventory reorder summary */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Inventory Reorder From Email"
                        name="inventoryReorderFromEmail"
                        value={formData.inventoryReorderFromEmail || ""}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        placeholder="Must be a configured email account"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Inventory Reorder To Emails"
                        name="inventoryReorderToEmails"
                        value={formData.inventoryReorderToEmails || ""}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        placeholder="Comma-separated emails"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} lg={6}>
              <Card variant="outlined" sx={{ height: "100%", overflow: "visible" }}>
                <CardContent sx={{ pb: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                    <SmartToyIcon color="primary" fontSize="small" />
                    <Typography variant="h6" fontWeight={500}>
                      AI Summary Configuration
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label="AI Summary System Prompt"
                        name="aiSummarySystemPrompt"
                        value={formData.aiSummarySystemPrompt}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        multiline
                        rows={6}
                        placeholder="Leave blank to use the built-in default prompt"
                        helperText="Instructions the AI follows when writing a lab report summary"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Quote Comments
              </Typography>
            </Grid>

            {/* Generic Comment */}
            <Grid item xs={12}>
              <TextField
                label="Generic Comment"
                name="quoteGenericComment"
                value={formData.quoteGenericComment}
                onChange={(e) =>
                  setFormData({ ...formData, quoteGenericComment: e.target.value })
                }
                fullWidth
                variant="outlined"
                size="small"
                multiline
                rows={4}
                error={!!errors.quoteGenericComment}
                helperText={errors.quoteGenericComment}
              />
            </Grid>

            {/* Waste Water Comment */}
            <Grid item xs={12} style={{ marginTop: "10px" }}>
              <TextField
                label="Waste Water Comment"
                name="quoteWasteWaterComment"
                value={formData.quoteWasteWaterComment}
                onChange={(e) =>
                  setFormData({ ...formData, quoteWasteWaterComment: e.target.value })
                }
                fullWidth
                variant="outlined"
                size="small"
                multiline
                rows={4}
                error={!!errors.quoteWasteWaterComment}
                helperText={errors.quoteWasteWaterComment}
              />
            </Grid>

            {/* Drinking Water Comment */}
            <Grid item xs={12} style={{ marginTop: "10px", marginBottom: "30px" }}>
              <TextField
                label="Drinking Water Comment"
                name="quoteDrinkingWaterComment"
                value={formData.quoteDrinkingWaterComment}
                onChange={(e) =>
                  setFormData({ ...formData, quoteDrinkingWaterComment: e.target.value })
                }
                fullWidth
                variant="outlined"
                size="small"
                multiline
                rows={4}
                error={!!errors.quoteDrinkingWaterComment}
                helperText={errors.quoteDrinkingWaterComment}
              />
            </Grid>


          </Grid>

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleCancelClick}
              size="large"
              sx={{ minWidth: 120 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveClick}
              size="large"
              sx={{ minWidth: 120 }}
              disabled={loading}
            >
              Save
            </Button>
          </Box>



        </Stack>
      </Container>
    </>
  );
};

export default UpdateSystemConfiguration;
